export default __webpack_public_path__ + "static/ip-brands-d329ec44d321a6538421d391408fd550.png";